import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { CSSPlugin } from "gsap/CSSPlugin";

import Common from "./utils/Common";
import LenisSmooth from "./utils/LenisSmooth";

// Import page modules
// When adding a new page class, you only need to import it here
import PageHome from "./page/PageHome";
import PageLocation from "./page/PageLocation";
import PageHouses from "./page/PageHouses";
import PageUHR from "./page/PageUHR";
import PageWR from "./page/PageWR";
import PageSustainability from "./page/PageSustainability";
import PageDesign from "./page/PageDesign";
import PageTeam from "./page/PageTeam";
import PageMedia from "./page/PageMedia";
import PageEnquiry from "./page/PageEnquiry";
import PagePrivacyPolicy from "./page/PagePrivacyPolicy";
import PageCookiesPolicy from "./page/PageCookiesPolicy";
import PageDisclaimer from "./page/PageDisclaimer";
import PageTermsConditions from "./page/PageTermsConditions";

// Register all needed plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, CSSPlugin);

window.addEventListener("load", async () => {
  // initialize smooth scrolling (Lenis) before initializing page modules
  try {
    const lenis = new LenisSmooth();
    lenis.init();
    // expose for debugging
    window.lenisSmooth = lenis;
  } catch (e) {
    // noop if Lenis fails
    // eslint-disable-next-line no-console
    console.warn("Lenis initialization failed", e);
  }

  let common = new Common();
  common.init();

  initPage();
});

const initPage = () => {
  // Get current page element
  const currentPage = document.querySelector(".page");

  if (!currentPage) return;

  // Get page ID from the current page element
  const pageId = currentPage.id;

  if (!pageId) return;

  // Create a mapping of page IDs to their class constructors
  // The system will automatically detect the page ID and initialize the corresponding class
  const pageClasses = {
    // Add new pages here automatically by following the pattern:
    // 'page-id': PageClass,
    home: PageHome,
    location: PageLocation,
    houses: PageHouses,
    uhr: PageUHR,
    wr: PageWR,
    design: PageDesign,
    sustainability: PageSustainability,
    team: PageTeam,
    media: PageMedia,
    enquiry: PageEnquiry,
    privacyPolicy: PagePrivacyPolicy,
    cookiesPolicy: PageCookiesPolicy,
    disclaimer: PageDisclaimer,
    termsConditions: PageTermsConditions,
    enquiryCompare: PageEnquiry,
  };

  // Initialize the page if a matching class is found
  if (pageClasses[pageId]) {
    const pageInstance = new pageClasses[pageId](currentPage);
    // expose the current page instance for debugging and runtime control
    window.currentPageInstance = pageInstance;
    console.log(`Initialized page: ${pageId}`);
  } else {
    console.warn(`No page module found for ID: ${pageId}`);
  }
};
